module.exports = {"beats":[[320,1],[509,2],[700,3],[895,2],[1086,1],[1280,2],[1480,3],[1676,2],[1873,2],[2069,2],[2265,2],[2457,2],[2644,2],[2834,2],[3023,2],[3217,2],[3408,2],[3603,2],[3811,2],[4029,2],[4242,2],[4462,2],[4680,2],[4889,2],[5091,2],[5294,2],[5492,2],[5687,2],[5882,2],[6075,2],[6265,2],[6465,2],[6661,2],[6865,2],[7067,2],[7271,2],[7477,2],[7680,2],[7881,2],[8085,2],[8286,2],[8481,2],[8677,2]]}


//////////////////
// WEBPACK FOOTER
// ./src/views/pages/Annotation/data/beatAnnotation.json
// module id = 3679
// module chunks = 23